import * as api from "../generated-api";
import { apiCall, apiCallWithResponse } from "../common";
import { processDownload } from "./documents";
import { AxiosResponse } from "axios";

export const getDealDocumentSignatures = (
  orgId: number,
  dealId: number,
  successCallback?: (documentSignature: api.DealDocumentSignature[]) => void,
  errorCallback?: (error: Error) => void
) => {
  apiCall<api.DealDocumentSignature[]>(
    () => {
      return api.getDealSignatures(orgId, dealId);
    },
    successCallback,
    errorCallback
  );
};

export const getDealSignaturesForUser = (
  orgId: number,
  dealId: number,
  userId: number,
  successCallback?: (documentSignatures: api.DealDocumentSignature[]) => void,
  errorCallback?: (error: Error) => void
) => {
  apiCall<api.DealDocumentSignature[]>(
    () => {
      return api.getDealSignaturesForUser(orgId, dealId, userId);
    },
    successCallback,
    errorCallback
  );
};

export const getDealSignaturePacketDownloadPDFForUser = (
  orgId: number,
  dealId: number,
  personId: number,
  successCallback?: (response: AxiosResponse) => void,
  errorCallback?: (error: Error) => void
) => {
  apiCallWithResponse(
    () => {
      return api.getDealSignaturePacketDownloadPDFForUser(
        orgId,
        dealId,
        personId,
        {
          responseType: "blob",
        }
      );
    },
    (response) => {
      processDownload(response, "signature-packet.pdf"); // this name is only used if the header doesn't include a filename; eg it isn't used

      successCallback(response);
    }
  ),
    errorCallback;
};

export const updateDealDocumentSignature = (
  orgId: number,
  dealId: number,
  docId: number,
  updateValue: api.DealDocumentSignatureUpdate,
  successCallback?: (
    documentSignaturesWithContents: api.DealDocumentSignatureWithSignatureContent[]
  ) => void,
  errorCallback?: (error: Error) => void
) => {
  apiCall<api.DealDocumentSignatureWithSignatureContent[]>(
    () => {
      return api.updateDealDocumentSignature(orgId, dealId, docId, [
        updateValue,
      ]);
    },
    successCallback,
    errorCallback
  );
};

export const updateDealDocumentSignatures = (
  orgId: number,
  dealId: number,
  docId: number,
  updateValues: api.DealDocumentSignatureUpdate[],
  successCallback?: (
    documentSignaturesWithContents: api.DealDocumentSignatureWithSignatureContent[]
  ) => void,
  errorCallback?: (error: Error) => void
) => {
  apiCall<api.DealDocumentSignatureWithSignatureContent[]>(
    () => {
      return api.updateDealDocumentSignature(
        orgId,
        dealId,
        docId,
        updateValues
      );
    },
    successCallback,
    errorCallback
  );
};

export const signDealDocument = (
  orgId: number,
  dealId: number,
  docId: number,
  signatureId: number,
  successCallback?: (
    documentSignaturesWithContents: api.DealDocumentSignatureWithSignatureContent
  ) => void,
  errorCallback?: (error: Error) => void
) => {
  updateDealDocumentSignature(
    orgId,
    dealId,
    docId,
    {
      id: signatureId,
      status: "signed",
    },
    (
      documentSignaturesWithContents: api.DealDocumentSignatureWithSignatureContent[]
    ) => {
      successCallback(documentSignaturesWithContents[0]);
    },
    errorCallback
  );
};

export const getDealDocumentSignatureById = (
  orgId: number,
  dealId: number,
  documentId: number,
  signerId: number,
  successCallback?: (
    dealSigner: api.DealDocumentSignatureWithSignatureContent
  ) => void,
  errorCallback?: (error: Error) => void
) => {
  apiCall<api.DealDocumentSignatureWithSignatureContent>(
    () => {
      return api.getDealDocumentSignatureById(
        orgId,
        dealId,
        documentId,
        signerId
      );
    },
    successCallback,
    errorCallback
  );
};
